import {
  EntrancePlantDetailDTO,
  EntrancePlantInfoCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import DialogReportEpIssue from './DialogReportEpIssue/DialogReportEpIssue.vue';

@Options({
  name: 'SubmitIssueTab',
  props: {
    infoPlant: {
      type: EntrancePlantInfoCreateDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {
    DialogReportEpIssue,
  },
  emits: ['update-list'],
})
export default class SubmitIssueTab extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  infoPlant!: EntrancePlantDetailDTO;
  isVisibleDialogIssueProblem = false;

  mounted() {}

  toggleReportIssueDialog() {
    this.isVisibleDialogIssueProblem = !this.isVisibleDialogIssueProblem;
  }
}
